import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { useFormValueSelector } from '@mews-commander/legacy-form';
import { EDIT_COUNTER_DIALOG } from '../constants';
import { useCounter } from '../queries/useCounters';
import { updateAccountingCounter, updateBillCounter } from '../actions';
import { isDialogOpen } from '../../dialog/selectors';
import { getBillCounterValues } from '../helpers';
import { CounterDialog } from './CounterDialog';
import { CounterFormField, CounterFormValues } from './CounterForm/formMapping';

export const EditCounterDialog = () => {
    const active = useCommanderSelector((state) => isDialogOpen(state, { name: EDIT_COUNTER_DIALOG }));
    const counterId = useFormValueSelector(EDIT_COUNTER_DIALOG, 'counterId');
    const dispatch = useCommanderThunkDispatch();

    const { data: counter } = useCounter(counterId);

    if (!counter || !active) {
        return null;
    }

    const onSubmit = async (values: CounterFormValues) => {
        if (counter.data.discriminator === EnterpriseScopeCounterDiscriminator.BillCounter) {
            await dispatch(updateBillCounter(counter, values));
        } else {
            await dispatch(updateAccountingCounter(counter, values));
        }
    };

    const { title, billTypeCode, displayCid, creditNoteTitle } = getBillCounterValues(counter);

    const defaultValues: CounterFormValues = {
        [CounterFormField.Name]: counter.name,
        [CounterFormField.StartValue]: counter.value,
        [CounterFormField.NumberFormat]: counter.format,
        [CounterFormField.Title]: title,
        [CounterFormField.BillTypeCode]: billTypeCode,
        [CounterFormField.Created]: counter.createdUtc,
        [CounterFormField.Updated]: counter.updatedUtc,
        [CounterFormField.IsDefault]: counter.isDefault,
        [CounterFormField.DisplayCID]: displayCid,
        [CounterFormField.CreditNoteTitle]: counter.isDefault ? creditNoteTitle : '',
    };

    return <CounterDialog isEditForm name={EDIT_COUNTER_DIALOG} onSubmit={onSubmit} defaultValues={defaultValues} />;
};
